import React from 'react';
import { OverlayTrigger, PopOver, Icon } from '@tencent/spaui';
import './index.scoped.less';

const TipIcon = (props: {
  value?: any;
  children: any;
  overlayTriggerProps?: Record<string, any>;
  popOverProps?: Record<string, any>;
}) => {
  const { value = null, children, overlayTriggerProps = {}, popOverProps = {} } = props;
  return <>
    {value}
    {!!children && <OverlayTrigger
      placement="bottom"
      alignment="left"
      {...overlayTriggerProps}
      overlay={
        <PopOver {...popOverProps}>{children}</PopOver>
      }
    >
      <Icon className="tip-icon" name='question-filled' />
    </OverlayTrigger>}
  </>;
};

export default TipIcon;
